import { render } from "./VerImagenCarouselModal.vue?vue&type=template&id=78b5daac"
import script from "./VerImagenCarouselModal.vue?vue&type=script&lang=js"
export * from "./VerImagenCarouselModal.vue?vue&type=script&lang=js"

import "./VerImagenCarouselModal.vue?vue&type=style&index=0&id=78b5daac&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__